import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/FirldTrips/2023/Class10/1.jpg';
// import p2 from 'assests/Photos/FirldTrips/2023/Class10/2.jpg';
// import p3 from 'assests/Photos/FirldTrips/2023/Class10/3.jpg';
// import p4 from 'assests/Photos/FirldTrips/2023/Class10/4.jpg';
// import p5 from 'assests/Photos/FirldTrips/2023/Class10/5.jpg';
// import p6 from 'assests/Photos/FirldTrips/2023/Class10/6.jpg';
// import p7 from 'assests/Photos/FirldTrips/2023/Class10/7.jpg';
// import p8 from 'assests/Photos/FirldTrips/2023/Class10/8.jpg';
// import p9 from 'assests/Photos/FirldTrips/2023/Class10/9.jpg';
// import p10 from 'assests/Photos/FirldTrips/2023/Class10/10.jpg';
// import p11 from 'assests/Photos/FirldTrips/2023/Class10/11.jpg';
// import p12 from 'assests/Photos/FirldTrips/2023/Class10/12.jpg';
// import p13 from 'assests/Photos/FirldTrips/2023/Class10/13.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import Sidebar_2023 from '../Sidebar_2023';


const CurricularClass102023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/4.webp`;
    const p5 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/5.webp`;
    const p6 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/6.webp`;
    const p7 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/7.webp`;
    const p8 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/8.webp`;
    const p9 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/9.webp`;
    const p10 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/10.webp`;
    const p11 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/11.webp`;
    const p12 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/12.webp`;
    const p13 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/co-curricular-activities/class10/13.webp`;
  

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },

        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }, {
            src: p7,
            source: p7,
            rows: 1,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1,
            cols: 1,
        },
        {
            src: p10,
            source: p10,
            rows: 1,
            cols: 1,
        },
        {
            src: p11,
            source: p11,
            rows: 1,
            cols: 1,
        },
        {
            src: p12,
            source: p12,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p13,
            source: p13,
            rows: 1,
            cols: 2,
        }

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    ‘Field Trip to Kaadgal Resort’
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 10   Date: 25 SEPTEMBER 2023

                                </Typography>
                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    On 25 September 2023, Class 10  grade students embarked on a memorable field trip to Kaadgal Resort, nestled on the picturesque Kanakapura Road. The journey itself was marked by vibrant energy as they all danced and sang heartily turning the bus ride into a joyful prelude to an exciting day ahead.
                                    <br />
                                    Upon arriving at Kaadgal Resort, the day began with a delicious breakfast, which provided the necessary fuel for the adventures awaiting instore. They were divided into two teams. The first group engaged in an exhilarating rope course challenge, while the second group focused on their archery skills and enjoyed a spirited game of cricket and football. This division allowed everyone to choose their preferred activities and make the most of their day.
                                    <br />
                                    After the morning activities, both groups reconvened for a refreshing rain dance session and a relaxing swim. The playful splashes and groovy tunes turned the pool area into a lively dance floor and the cool waters offered a welcome respite from the day's activities.
                                    <br />
                                    Following our water escapades, we gathered for a sumptuous lunch that satisfied our appetites. The resort's serene amphitheatre provided the perfect backdrop for group photos, capturing the smiles and camaraderie of the day. As memories preserved in photographs, they bid adieu to Kaadgal Resort and embarked on the return bus ride.
                                    <br />
                                    The field trip to Kaadgal Resort was a resounding success, offering a perfect blend of adventure, relaxation, and bonding. It was a day filled with laughter, fun, and shared experiences that would be cherished for years to come.
                                </Typography>
                            </Box>


                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar_2023 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default CurricularClass102023;